import { ModuleNames } from '../../src/constants/componentNames.constants'
import { getComponentType } from '../preview.utils'
import formatTopicAgendaData from '../topic/agenda'
import formatTopicFAQData from '../topic/faq'

export default (data: any) => ({
  topPadding: data?.fields?.topPadding,
  bottomPadding: data?.fields?.bottomPadding,
  theme: data?.fields?.theme,
  title: data?.fields?.title,
  useCase: data?.fields?.useCase,
  rows: data?.fields?.rows?.length
    ? data.fields.rows
        .map((row: any) => {
          let contentType = getComponentType(row)
          switch (contentType) {
            case ModuleNames.TOPIC_FAQ:
              return formatTopicFAQData(row)
            case ModuleNames.TOPIC_AGENDA:
              return formatTopicAgendaData(row)
            default:
              return null
          }
        })
        .filter((row: any) => row !== null && row !== undefined)
    : null,
  __typename: ModuleNames.CONTENT_ROWS,
})
